export const onlyLettersRegExp = /^[a-zA-Zа-яА-ЯіІєЄїЇ\s]+$/; // regExp to enter only letters
export const regExpEnglishAndSpace = /^[a-zA-Z\s]+$/; // regExp to enter only English letters And Space
export const emailValidationPattern =
  '^[A-Za-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$';
